import React, { useCallback, useState } from 'react';
import { View } from '../../../../Enums/View.enum';
import { WorkplacePatientStatus } from '../../Enums/WorkplacePatientStatus.enum';
import EArchiveListItemListView from './EArchiveListItemListView';
import EArchiveListItemGridView from './EArchiveListItemGridView';
import TreatmentModal from '../../../../Components/Treatment/TreatmentModal';
import WorkplaceWorkerDetailModal from '../../../Manager/Components/WorkplaceWorker/WorkplaceWorkerDetail/WorkplaceWorkerDetailModal';
import { useSelectUsersContext } from '../../Services/SelectUsersContext';
import { WorkplaceMemberSource } from '../../../../graphql/graphql';

export interface EArchiveItem {
	id: string;
	createdAt: string;
	status: WorkplacePatientStatus;
	user: {
		id: string;
		profile: {
			birthDate: string;
			birthNumber: string;
			formattedBirthNumber: string;
			age: string;
			contactEmail: string;
			contactPhoneNumber: string;
			firstName: string;
			lastName: string;
			fullName: string;
			insuranceCompanyTermItem: {
				id: string;
				value: string;
				value2: string;
			};
			address: {
				fullAddress: string;
				street: string;
				guideNumber: string;
				descriptiveNumber: string;
				city: string;
				postCode: string;
			};
		};
		profileImageUrl: string;
		avatarUrl: string;
		csszResult: {
			result: any;
			checkedAt: string;
		};
		vzpResult: {
			result: any;
			checkedAt: string;
		};
		hasMeddi: boolean;
		email: string;
		formattedPhoneNumber: string;
		isChild: boolean;
		parents: {
			profile: {
				fullName: string;
			};
			formattedPhoneNumber: string;
			email: string;
		}[];
		workplaceMember?: {
			dateOfDeath?: boolean;
			source?: WorkplaceMemberSource;
		};
	};
}

interface Props {
	item: EArchiveItem;
	onRefresh?: () => void;
	view: View;
	groupType?: string;
}

const EArchiveListItem: React.FC<Props> = ({
	view,
	item,
	onRefresh,
	groupType,
}) => {
	const [isDetailOpen, setDetailOpen] = useState(false);
	const { showSelectCheckbox, onToggleUser } = useSelectUsersContext();

	const isAllDoctorsGroup = groupType === 'all_doctors';

	const handleOnClick = useCallback(() => {
		return showSelectCheckbox
			? onToggleUser(item.user.id)
			: setDetailOpen(true);
	}, [showSelectCheckbox, item.user.id, onToggleUser]);

	let component = <></>;
	switch (view) {
		case View.LIST:
			component = (
				<EArchiveListItemListView
					item={item}
					onClick={() => setDetailOpen(true)}
				/>
			);
			break;
		case View.GRID:
			component = (
				<EArchiveListItemGridView item={item} onClick={handleOnClick} />
			);
			break;
	}

	return (
		<>
			{component}
			{isDetailOpen && isAllDoctorsGroup && (
				<WorkplaceWorkerDetailModal
					isOpen
					userId={item.user.id}
					onClose={() => setDetailOpen(false)}
					showAllWorkplaces={false}
					onWorkplaceEdit={() => {
						setDetailOpen(false);
						onRefresh?.();
					}}
				/>
			)}
			{isDetailOpen && !isAllDoctorsGroup && (
				<TreatmentModal
					opened
					patientId={item.user.id}
					onClose={() => setDetailOpen(false)}
					onRefresh={onRefresh}
				/>
			)}
		</>
	);
};

export default EArchiveListItem;
